import { useAppointmentRepository } from '@/repositories/appointmentRepo'

export function useAppointmentRecents() {
  const DEFAULT_LIMIT = 5
  const appointmentRepo = useAppointmentRepository()

  const fetchLimitedRecentAppointments = async (limit: number = DEFAULT_LIMIT) => {
    return appointmentRepo.fetchRecentAppointments(limit)
  }

  return {
    DEFAULT_LIMIT,
    fetchLimitedRecentAppointments,
  }
}
